import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../../components/feature/SEOHead';
import ExercicioGratisNavbar from '../components/ExercicioGratisNavbar';
import LeadCaptureForm from '../components/LeadCaptureForm';

export default function AmorIdealPage() {
  const [selectedQualities, setSelectedQualities] = useState<string[]>([]);

  const qualities = [
    { id: 'respeito', label: 'Respeito Mútuo', icon: 'ri-heart-line', color: 'bg-rose-100 text-rose-600' },
    { id: 'comunicacao', label: 'Comunicação Aberta', icon: 'ri-chat-3-line', color: 'bg-pink-100 text-pink-600' },
    { id: 'cumplicidade', label: 'Cumplicidade', icon: 'ri-team-line', color: 'bg-purple-100 text-purple-600' },
    { id: 'confianca', label: 'Confiança', icon: 'ri-shield-check-line', color: 'bg-indigo-100 text-indigo-600' },
    { id: 'apoio', label: 'Apoio Mútuo', icon: 'ri-hand-heart-line', color: 'bg-blue-100 text-blue-600' },
    { id: 'crescimento', label: 'Crescimento Conjunto', icon: 'ri-plant-line', color: 'bg-teal-100 text-teal-600' },
    { id: 'paixao', label: 'Paixão e Intimidade', icon: 'ri-fire-line', color: 'bg-red-100 text-red-600' },
    { id: 'diversao', label: 'Diversão e Leveza', icon: 'ri-emotion-happy-line', color: 'bg-amber-100 text-amber-600' },
  ];

  const toggleQuality = (id: string) => {
    setSelectedQualities(prev => prev.includes(id) ? prev.filter(q => q !== id) : [...prev, id]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-purple-50">
      <SEOHead
        title="Visualização do Amor Ideal Grátis | Manifestação — Carta do Eu Futuro"
        description="Experimente gratuitamente a Visualização do Amor Ideal. Conecte-se com a energia do relacionamento que você deseja manifestar através da visualização criativa e PNL."
        keywords="amor ideal, visualização, manifestação, relacionamento, PNL grátis"
        canonical="/exercicio-gratis/amor-ideal"
      />
      <ExercicioGratisNavbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-rose-500/10 via-pink-500/10 to-purple-500/10"></div>
        <div className="max-w-6xl mx-auto relative z-10 text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 px-4 py-2 rounded-full text-sm font-semibold mb-6"><i className="ri-gift-line"></i>VERSÃO GRATUITA</div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-rose-600 via-pink-600 to-purple-600 bg-clip-text text-transparent leading-tight">Visualização do Amor Ideal</h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-8">Conecte-se com a energia do relacionamento que você deseja manifestar através da visualização criativa</p>
        </div>
      </section>

      {/* O que é */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900">O que é a Visualização do Amor Ideal?</h2>
          <p className="text-lg leading-relaxed mb-6 text-gray-700">A <strong>Visualização do Amor Ideal</strong> combina neurociência, PNL e lei da atração para ajudá-lo a manifestar o relacionamento dos seus sonhos.</p>
          <p className="text-lg leading-relaxed text-gray-700">Ao visualizar com clareza as qualidades, sentimentos e experiências que você deseja, você programa seu cérebro para reconhecer e atrair essas oportunidades na vida real.</p>
        </div>
      </section>

      {/* Exercício */}
      <section className="py-16 px-4 bg-gradient-to-br from-rose-50 to-pink-50">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl p-8 md:p-12">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 px-4 py-2 rounded-full text-sm font-semibold mb-4"><i className="ri-gift-line"></i>EXPERIMENTE GRÁTIS</div>
              <h2 className="text-3xl font-bold mb-4 text-gray-900">Exercício Introdutório</h2>
            </div>
            <h3 className="text-xl font-bold mb-6 text-gray-900">Selecione as qualidades mais importantes para você:</h3>
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              {qualities.map((quality) => (
                <button key={quality.id} onClick={() => toggleQuality(quality.id)} className={`p-4 rounded-xl border-2 transition-all text-left cursor-pointer ${selectedQualities.includes(quality.id) ? 'border-rose-500 bg-rose-50 scale-105' : 'border-gray-200 bg-white hover:border-rose-300'}`}>
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 ${quality.color} rounded-lg flex items-center justify-center`}><i className={`${quality.icon} text-xl`}></i></div>
                    <span className="font-semibold text-gray-900">{quality.label}</span>
                    {selectedQualities.includes(quality.id) && <i className="ri-checkbox-circle-fill text-rose-500 text-xl ml-auto"></i>}
                  </div>
                </button>
              ))}
            </div>
            {selectedQualities.length > 0 && <div className="p-4 bg-rose-50 rounded-xl border border-rose-200 mb-6"><p className="text-sm text-rose-700 font-medium">Você selecionou {selectedQualities.length} qualidade{selectedQualities.length > 1 ? 's' : ''} essencial{selectedQualities.length > 1 ? 'is' : ''}!</p></div>}
            {/* Bloqueados */}
            <div className="relative mt-6">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/60 to-white backdrop-blur-sm z-10 rounded-2xl flex items-center justify-center">
                <div className="bg-gradient-to-r from-rose-500 via-pink-500 to-purple-500 text-white p-8 rounded-2xl text-center max-w-sm">
                  <i className="ri-vip-crown-line text-5xl mb-4 block"></i>
                  <h3 className="text-2xl font-bold mb-3">Desbloqueie o Exercício Completo</h3>
                  <p className="text-rose-100 mb-6">Acesse todos os 6 passos + áudios guiados</p>
                  <Link to="/planos" className="bg-white text-rose-600 px-8 py-4 rounded-xl font-bold hover:bg-rose-50 transition-all whitespace-nowrap block">Ver Planos — A partir de R$ 18</Link>
                </div>
              </div>
              <div className="opacity-30 pointer-events-none space-y-4">
                {[2,3,4,5,6].map((n) => <div key={n} className="p-6 bg-gray-50 rounded-xl border-2 border-gray-200"><h3 className="font-bold text-gray-600">Passo {n} — bloqueado</h3></div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <LeadCaptureForm exercicioNome="Amor Ideal (Visualização)" />

      {/* CTA Final */}
      <section className="py-20 px-4 bg-gradient-to-br from-charcoal-950 via-charcoal-900 to-charcoal-950 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-12 h-px bg-gold-500/30 mx-auto mb-8"></div>
          <i className="ri-heart-3-fill text-5xl mb-6 opacity-60 block text-gold-400"></i>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold mb-6 text-white">Pronto para Manifestar o Amor da Sua Vida?</h2>
          <p className="text-xl text-white/55 mb-8 max-w-2xl mx-auto font-['Montserrat'] font-light">Desbloqueie o exercício completo e comece sua jornada de manifestação do amor ideal hoje mesmo</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/planos" className="bg-gradient-to-r from-gold-500 to-gold-700 text-charcoal-900 px-10 py-5 rounded-xl font-bold hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat'] tracking-wide">Ver Planos e Preços</Link>
            <Link to="/" className="bg-white/8 text-white px-10 py-5 rounded-xl font-bold hover:bg-white/14 transition-all border border-gold-500/20 whitespace-nowrap font-['Montserrat'] tracking-wide">Voltar ao Início</Link>
          </div>
          <p className="text-white/30 text-sm mt-6 font-['Montserrat']">Garantia de 7 dias · Acesso vitalício · Suporte incluído</p>
        </div>
      </section>
    </div>
  );
}
